import { AnchorHTMLAttributes, FC, MouseEvent } from 'react';

import { styled } from '../theme';
import Text from './Text';

const StyledLink = styled(Text.withComponent('a'))(({ theme }) => ({
    cursor: 'pointer',
    textDecoration: 'none',
    color: theme.color.primary1,
    ':hover, :focus': {
        color: theme.color.primary2,
    },
    ':active': {
        color: theme.color.primary3,
    },
}));

type Props = AnchorHTMLAttributes<HTMLAnchorElement> & {
    href?: string;
    scrollOptions?: ScrollIntoViewOptions;
};

const Link: FC<Props> = ({ href, onClick, scrollOptions, ...props }) => {
    const handleClick = (e: MouseEvent<HTMLAnchorElement>) => {
        // Only handle hash links (href starting with #)
        if (href?.startsWith('#')) {
            e.preventDefault();

            // Extract the hash from href (e.g., "#cdn" -> "cdn")
            const hash = href.slice(1);
            const element = document.getElementById(hash);

            if (element) {
                element.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start',
                    ...scrollOptions,
                });
            }
        }

        onClick?.(e);
    };

    return <StyledLink href={href} onClick={handleClick} {...props} />;
};

export default Link;
